import { render, staticRenderFns } from "./MetaDataTable.vue?vue&type=template&id=c94678ca&scoped=true&lang=pug&"
import script from "./MetaDataTable.vue?vue&type=script&lang=js&"
export * from "./MetaDataTable.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataTable.vue?vue&type=style&index=0&id=c94678ca&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94678ca",
  null
  
)

export default component.exports